<template>
  <div class="view-container qr-wrapper">
    <div v-if="error" class="text-container">
      <p>{{ error }}</p>
    </div>

    <h3>Scan QR Code</h3>

    <app-qrcode
      @decode="onDecode"
      @init="onInit"
      :track="paintOutline"
      v-if="!destroyed"
      class="stream"
    >
      <div>
        <img
          src="@/assets/ScannerBorders.png"
          class="borders"
          v-if="!loading && !destroyed"
        />
      </div>
      <div class="loading-indicator" v-if="loading">Loading...</div>
    </app-qrcode>
  </div>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
export default {
  name: 'QRCScanner',
  components: {
    'app-qrcode': QrcodeStream
  },
  data() {
    return {
      result: '',
      error: '',
      loading: false,
      destroyed: false
    };
  },
  methods: {
    onDecode(decodedURL) {
      if (window.location.origin != new URL(decodedURL).origin)
        this.showToaster('Oops', 'Invalid QR code scanned.', 'danger');
      else window.location.href = decodedURL;
    },

    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = 'red';

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },

    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.showToaster(
            'Oops',
            'You need to grant camera access permisson.',
            'danger'
          );
        } else if (error.name === 'NotFoundError') {
          this.showToaster('Oops', 'No camera found on this device.', 'danger');
        } else if (error.name === 'NotSupportedError') {
          this.showToaster(
            'Oops',
            "A secure 'https' connection was required.",
            'danger'
          );
        } else if (error.name === 'NotReadableError') {
          this.showToaster(
            'Oops',
            'The camera might already be in use.',
            'danger'
          );
        } else if (error.name === 'OverconstrainedError') {
          this.showToaster(
            'Oops',
            'Installed cameras are not suitable.',
            'danger'
          );
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.showToaster(
            'Oops',
            'The browser you are using is not supported.',
            'danger'
          );
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.text-container {
  margin: 15px;
  padding: 10px;
}

.text-container > p {
  color: red;
  text-align: center;
  line-height: 0;
}

.loading-indicator {
  font-weight: bold;
  font-size: 2rem;
  text-align: center;
}

.borders {
  width: 70%;
  max-width: 400px;
  display: block;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.stream {
  bottom: 0;
  right: 0;
  left: 0;
  height: 85vh;
}

.view-container.qr-wrapper {
  text-align: center;
  padding-bottom: 0;
}
</style>
